"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHoseCodesForAtoms = exports.HOSE_CODE_CUT_C_SP3_SP3 = exports.FULL_HOSE_CODE = void 0;
const ensureHeterotopicChiralBonds_js_1 = require("../diastereotopic/ensureHeterotopicChiralBonds.js");
const tagAtom_1 = require("../util/tagAtom");
const getHoseCodesForAtomsInternal_js_1 = require("./getHoseCodesForAtomsInternal.js");
exports.FULL_HOSE_CODE = 1;
exports.HOSE_CODE_CUT_C_SP3_SP3 = 2;
/**
 * Returns the hose code for specific atom numbers
 * @param {import('openchemlib').Molecule} originalMolecule - The OCL molecule to be fragmented
 * @param {number[]} rootAtoms
 * @param {object} [options={}]
 * @param {number} [options.minSphereSize=0] Smallest hose code sphere
 * @param {number} [options.maxSphereSize=4] Largest hose code sphere
 * @param {number} [options.kind=FULL_HOSE_CODE] Kind of hose code, default usual sphere
 */
function getHoseCodesForAtoms(originalMolecule, rootAtoms = [], options = {}) {
    const { minSphereSize = 0, maxSphereSize = 4, kind = exports.FULL_HOSE_CODE, } = options;
    const molecule = originalMolecule.getCompactCopy();
    // those 2 lines should be done only once
    molecule.addImplicitHydrogens();
    (0, ensureHeterotopicChiralBonds_js_1.ensureHeterotopicChiralBonds)(molecule);
    const allowedCustomLabels = [];
    for (const rootAtom of rootAtoms) {
        allowedCustomLabels.push((0, tagAtom_1.tagAtom)(molecule, rootAtom));
    }
    return (0, getHoseCodesForAtomsInternal_js_1.getHoseCodesForAtomsInternal)(molecule, {
        minSphereSize,
        maxSphereSize,
        allowedCustomLabels,
        kind,
    });
}
exports.getHoseCodesForAtoms = getHoseCodesForAtoms;
//# sourceMappingURL=getHoseCodesForAtoms.js.map